import { NavLink } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";

const navItems = [
	{
		to: "/",
		icon: "dashboard",
		label: "Dashboard",
	},
	{
		to: "/ratings",
		icon: "history",
		label: "Drink Log",
	},
	{
		to: "/profile",
		icon: "person",
		label: "My Profile",
	},
];

export function Sidebar() {
	const { user } = useAuth();
	const handleSignOut = () => supabase.auth.signOut();

	return (
		<nav className="hidden md:flex h-screen w-72 fixed left-0 top-0 border-r-4 border-brand-black bg-surface-container-lowest flex flex-col p-6 z-50 shadow-[8px_0px_0px_0px_rgba(0,0,0,1)]">
			<div className="text-2xl font-black italic text-brand-black border-b-4 border-brand-black pb-4 mb-8">
				ENERGY
			</div>

			<div className="flex-1 flex flex-col gap-2">
				{navItems.map((item) => (
					<NavLink
						key={item.label}
						to={item.to}
						end={item.to === "/"}
						className={({ isActive }) =>
							`flex items-center p-4 gap-3 transition-all font-[Space_Grotesk] uppercase font-bold tracking-tighter ${
								isActive && item.label !== "My Profile"
									? "bg-brand-blue text-brand-white border-4 border-brand-black translate-x-1 translate-y-1 shadow-none"
									: "text-brand-black border-2 border-brand-black bg-surface-container-lowest hover:bg-brand-yellow hover:translate-x-1 hover:translate-y-1"
							}`
						}
					>
						{({ isActive }) => (
							<>
								<span
									className="material-symbols-outlined"
									style={{
										fontVariationSettings: `'FILL' ${isActive && item.label !== "My Profile" ? 1 : 0}`,
									}}
								>
									{item.icon}
								</span>
								{item.label}
							</>
						)}
					</NavLink>
				))}
			</div>

			<div className="mt-auto">
				<NavLink
					to="/ratings/new"
					className="w-full bg-brand-green border-4 border-brand-black p-4 text-brand-black font-[Space_Grotesk] uppercase font-bold tracking-tighter hover:translate-x-1 hover:translate-y-1 transition-all shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-none text-center block"
				>
					RATE NOW
				</NavLink>

				<div className="mt-6 pt-6 border-t-4 border-brand-black flex items-center gap-4">
					<div className="w-12 h-12 rounded-full border-2 border-brand-black bg-secondary-container flex items-center justify-center overflow-hidden shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
						<span
							className="material-symbols-outlined text-[24px] text-brand-black"
							style={{ fontVariationSettings: "'FILL' 1" }}
						>
							person
						</span>
					</div>
					<div className="min-w-0">
						<p className="font-label-bold text-[14px] leading-none font-bold font-[Space_Grotesk] truncate">
							{user?.user_metadata?.full_name ||
								user?.user_metadata?.name ||
								"Caffeine Fiend"}
						</p>
						<p className="font-body-md text-[13px] leading-[1.5] text-outline">
							Stay Caffeinated
						</p>
					</div>
				</div>

				<button
					onClick={handleSignOut}
					className="w-full mt-4 border-2 border-brand-black p-3 text-on-surface-variant font-[Space_Grotesk] uppercase font-bold tracking-tighter hover:bg-error-container hover:text-on-error-container transition-colors text-sm"
				>
					SIGN OUT
				</button>
			</div>
		</nav>
	);
}
